import { render, staticRenderFns } from "./AdminDetail.vue?vue&type=template&id=badc8310&scoped=true"
import script from "./AdminDetail.vue?vue&type=script&lang=js"
export * from "./AdminDetail.vue?vue&type=script&lang=js"
import style0 from "./AdminDetail.vue?vue&type=style&index=0&id=badc8310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badc8310",
  null
  
)

export default component.exports